import { render, staticRenderFns } from "./honorDetail.vue?vue&type=template&id=25c55228&scoped=true"
import script from "./honorDetail.vue?vue&type=script&lang=js"
export * from "./honorDetail.vue?vue&type=script&lang=js"
import style0 from "./honorDetail.vue?vue&type=style&index=0&id=25c55228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c55228",
  null
  
)

export default component.exports